import { z } from 'zod';
import Locales from 'locales';
import { hasAgencyCategoryDependencies, resolveAgencyCategoryIds } from './agencyCategorySelection';

const agencyFields = {
  name: z.string().min(5, Locales.agency.errors.agency_name),
  ifu: z.string().regex(/^[0-9]{13}$/, Locales.agency.errors.ifu),
  phone: z.string().min(8, Locales.agency.errors.phone).max(15, Locales.agency.errors.phone),
  address: z.string().min(5, Locales.agency.errors.addr),
};

const categoryIdsField = (categories) =>
  z.preprocess(
    (value) => resolveAgencyCategoryIds(value, categories),
    z
      .array(z.string())
      .min(1, Locales.agency.errors.category_required)
      .refine((value) => hasAgencyCategoryDependencies(value, categories), Locales.agency.errors.category_required)
  );

export const addAgencySchema = (categories) =>
  z.object({
    ...agencyFields,
    admin_first_name: z.string().nonempty(Locales.agency.errors.empty_field),
    admin_last_name: z.string().nonempty(Locales.agency.errors.empty_field),
    admin_email: z.string().email(Locales.agency.errors.email),
    category_ids: categoryIdsField(categories),
  });

export const editAgencySchema = (categories) =>
  z.object({ ...agencyFields, category_ids: categoryIdsField(categories) });
